module.exports = __webpack_public_path__ + "img/app-qrcode(1).5b721444.jpg";